
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1349"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1349",
    "ar-eg": "static-7.1349",
    "bg": "static-7.1349",
    "bn": "static-7.1349",
    "ca-es": "static-7.1349",
    "cs": "static-7.1349",
    "da": "static-7.1349",
    "de": "static-7.1349",
    "el": "static-7.1349",
    "en-gb": "static-7.1349",
    "en": "static-7.1349",
    "es-mx": "static-7.1349",
    "es": "static-7.1349",
    "et": "static-7.1349",
    "fi": "static-7.1349",
    "fr-ca": "static-7.1349",
    "fr": "static-7.1349",
    "he-il": "static-7.1349",
    "hi": "static-7.1349",
    "hr": "static-7.1349",
    "hu": "static-7.1349",
    "id": "static-7.1349",
    "it": "static-7.1349",
    "ja": "static-7.1349",
    "ko": "static-7.1349",
    "lt": "static-7.1349",
    "ms": "static-7.1349",
    "nl": "static-7.1349",
    "no": "static-7.1349",
    "pl": "static-7.1349",
    "pt-br": "static-7.1349",
    "pt-pt": "static-7.1349",
    "ro": "static-7.1349",
    "ru": "static-7.1349",
    "sk": "static-7.1349",
    "sl": "static-7.1349",
    "sv": "static-7.1349",
    "th": "static-7.1349",
    "tl": "static-7.1349",
    "tr": "static-7.1349",
    "uk": "static-7.1349",
    "vi": "static-7.1349",
    "x-pseudo": "static-7.1349",
    "zh-cn": "static-7.1349",
    "zh-hk": "static-7.1349",
    "zh-tw": "static-7.1349"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1349'}); }
})();


